import { useState, useEffect } from 'react';

// ══════════════════════════════════════════════
//  原型持久化状态：写入 localStorage，刷新不丢
//  仅用于原型演示；联调时移除，改由接口读写
// ══════════════════════════════════════════════

export const usePersistentState = (key, initialValue) => {
  const [state, setState] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : initialValue;
    } catch (e) {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch (e) {
      // 忽略写入异常（如超配额），不影响页面使用
    }
  }, [key, state]);

  return [state, setState];
};

export default usePersistentState;
